module.exports = __webpack_public_path__ + "img/jff.a3e06d9c.png";